import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { API_BASE_URL } from "../../config";

export default function ResetPassword() {
    const [params] = useSearchParams();
    const token = params.get('token');
    const [form, setForm] = useState({ password: '', password2: '' });
    const [error, setError] = useState('');
    const [done, setDone] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) =>
        setForm({ ...form, [e.target.name]: e.target.value });

    async function handleSubmit(e) {
        e.preventDefault();
        setError('');
        if (form.password !== form.password2) {
            setError('Those passwords do not match.');
            return;
        }

        setSubmitting(true);
        try {
            const res = await fetch(`${API_BASE_URL}/api/auth/password-reset/confirm`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ token, password: form.password }),
            });
            const data = await res.json().catch(() => ({}));
            if (!res.ok) {
                // A rejected password leaves the token usable, so staying on
                // this page and letting them try again is correct.
                setError(data.message || 'That did not work.');
                setSubmitting(false);
                return;
            }
            setDone(true);
        } catch {
            setError('Network error. Your password was not changed.');
        }
        setSubmitting(false);
    }

    if (!token) {
        return (
            <div className="wb-page wb-page--narrow">
                <h1>Reset your password</h1>
                <div className="wb-note wb-note--danger">
                    This page needs a reset link. Request one and use the link in the email.
                </div>
                <p style={{ marginTop: '1.5rem' }}>
                    <Link to="/forgot-password" className="wb-btn wb-btn--primary">
                        Request a link
                    </Link>
                </p>
            </div>
        );
    }

    if (done) {
        return (
            <div className="wb-page wb-page--narrow">
                <h1>Password updated</h1>
                <p className="wb-sub">You can sign in with your new password now.</p>
                <button className="wb-btn wb-btn--primary" onClick={() => navigate('/login')}>
                    Sign in
                </button>
            </div>
        );
    }

    return (
        <div className="wb-page wb-page--narrow">
            <h1>Choose a new password</h1>

            <form onSubmit={handleSubmit} className="wb-card">
                <label className="wb-field">
                    <span className="wb-label">New password</span>
                    <input
                        className="wb-input" name="password" type="password"
                        autoComplete="new-password" required autoFocus
                        value={form.password} onChange={handleChange}
                    />
                    <span className="wb-hint">
                        At least 8 characters, with an upper and lower case letter, a number,
                        and one of @$!%*?&amp;
                    </span>
                </label>

                <label className="wb-field">
                    <span className="wb-label">Confirm new password</span>
                    <input
                        className="wb-input" name="password2" type="password"
                        autoComplete="new-password" required
                        value={form.password2} onChange={handleChange}
                    />
                </label>

                <button
                    type="submit"
                    className="wb-btn wb-btn--primary wb-btn--block"
                    disabled={submitting}
                >
                    {submitting ? 'Updating…' : 'Update password'}
                </button>

                {error && <div className="wb-note wb-note--danger" style={{ marginTop: '1rem' }}>{error}</div>}
            </form>
        </div>
    );
}
